export const validateEmail = (inputText) => {
    const mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    return !!inputText.match(mailformat)
}

export const removeDuplicatedDates = datesArray => {
    return [...new Set(datesArray)].map(d => new Date(d))
}